import request from "@/utils/request";

//直播详情
export function getLive(data) {
	return request({
		url: "/api/live/v1/live/",
		method: "POST",
		data,
	});
}

//用户信息
export function getUserinfo(params) {
	return request({
		url: "/api/live/v1/userinfo",
		method: "get",
		params,
	});
}
//储存用户信息
export function saveUserinfo(data) {
	return request({
		url: "/api/live/v1/usersave",
		method: "POST",
		data,
	});
}
//菜单详情
export function getLiveMenu(data) {
	return request({
		url: "/api/live/v1/live/menu",
		method: "POST",
		data,
	});
}

//获取产品列表
export function getGoods(data) {
	return request({
		url: "/api/live/v1/live/product",
		method: "POST",
		data,
	});
}

//获取产品详情
export function getGoodsDetail(data) {
	return request({
		url: "/api/live/v1/product/desc",
		method: "POST",
		data,
	});
}

//获取代理店
export function getAgent(data) {
	return request({
		url: "/api/live/v1/company",
		method: "POST",
		data,
	});
}

//提交询价
export function goodsEnquiry(data) {
	return request({
		url: "/api/live/v1/product/enquiry",
		method: "POST",
		data,
	});
}

//提交报名
export function goodsApply(data) {
	return request({
		url: "/api/live/v1/live/sendapply",
		method: "POST",
		data,
	});
}
// 获取直播间主播列表
export function anchorList(data) {
	return request({
		url: "/api/live/v1/anchor/list",
		method: "POST",
		data,
	});
}

//获取排行榜单
export function getRank(data) {
	return request({
		url: "/api/live/v1/live/rankinglist",
		method: "POST",
		data,
	});
}

//获取我的邀请列表
export function getMyRank(data) {
	return request({
		url: "/api/live/v1/live/myrank",
		method: "POST",
		data,
	});
}

//直播间签到
export function liveSign(data) {
	return request({
		url: "/api/live/v1/user/signIn",
		method: "POST",
		data,
	});
}

//获取验证码
export function getMobileCode(data) {
	return request({
		url: "/api/live/v1/mobile/",
		method: "POST",
		data,
	});
}

//收货地址
export function sendAddress(data) {
	return request({
		url: "/api/live/v1/winner/send",
		method: "POST",
		data,
	});
}

//邀请榜收货地址
export function inviteSendAddr(data) {
	return request({
		url: '/api/live/v1/live/myrankaddress',
		method: 'POST',
		data
	})
}

//获取抽奖信息
export function getLottery(data) {
	return request({
		url: "/api/live/v1/lottery/",
		method: "POST",
		data,
	});
}

//获取抽奖信息轮询
export function getLotteryRe(data) {
	return request({
		url: "/api/live/v1/lottery/",
		method: "POST",
		data,
	});
}

//获取抽奖参与中奖信息
export function getLotteryUser(data) {
	return request({
		url: "/api/live/v1/lottery/user",
		method: "POST",
		data,
	});
}

//获取全部中奖信息
export function getAllLotteryUser(data) {
	return request({
		url: "/api/live/v1/winner/all",
		method: "POST",
		data,
	});
}

//获取礼物
export function getGift(data) {
	return request({
		url: "/api/live/v1/live/present",
		method: "POST",
		data,
	});
}

//获取报名表
export function getApplyForm(data) {
	return request({
		url: "/api/live/v1/live/apply",
		method: "POST",
		data,
	});
}

//邀请码
export function submitLiveCode(data) {
	return request({
		url: "/api/live/v1/live/checkpass",
		method: "POST",
		data,
	});
}

//关注
export function attentionLive(data) {
	return request({
		url: "/api/live/v1/live/attention",
		method: "POST",
		data,
	});
}

//订阅提醒
export function attentionNotice(data) {
	return request({
		url: "/api/live/v1/live/remind",
		method: "POST",
		data,
	});
}

//创建红包
export function createMyRed(data) {
	return request({
		url: "/api/live/v1/createredpacket",
		method: "POST",
		data,
	});
}

//接收红包
export function redRecieve(data) {
	return request({
		url: "/api/live/v1/sendredpacket",
		method: "POST",
		data,
	});
}

//红包领取详情
export function redDetail(data) {
	return request({
		url: "/api/live/v1/redpacket/desc",
		method: "POST",
		data,
	});
}

//我的红包
export function allMyRed(data) {
	return request({
		url: "/api/live/v1/mysendredpacket",
		method: "POST",
		data,
	});
}

//我收到的红包
export function recieveMyRed(data) {
	return request({
		url: "/api/live/v1/myredpacket",
		method: "POST",
		data,
	});
}
//未开启红包列表
export function unopenRed(data) {
	return request({
		url: "/api/live/v1/redpacket/unopenList",
		method: "POST",
		data,
	});
}

//检查红包是否开启
export function checkRed(data) {
	return request({
		url: "/api/live/v1/checkRedpacket",
		method: "POST",
		data,
	});
}

//jssdk

export function getJssdk(data) {
	return request({
		url: `/api/live/v1/wechat/jssdk?url=` + data,
		method: "GET",
	});
}

//获取userinfo

export function getInfo(data) {
	return request({
		url: `/api/live/v1/wechat/userinfo?code=` + data,
		method: "GET",
	});
}

//获取置顶消息
export function getTopMaessage(data) {
	return request({
		url: "/api/live/v1/live/top",
		method: "POST",
		data,
	});
}

//获取红包剩余数量
export function getRedremained(data) {
	return request({
		url: "/api/live/v1/redpacket/get",
		method: "POST",
		data,
	});
}
//获取直播间公告
export function getnotice(data) {
	return request({
		url: `/api/live/v1/live/notice`,
		method: 'post',
		data
	})
}

//直播间聊天历史消息
export function historymessages(data) {
	return request({
		url: `/api/live/v1/comments`,
		method: 'get',
		params:data
	})
}

// 获取我的奖品
export function getmywinner(data) {
	return request({
		url: `/api/live/v1/winner/my`,
		method: 'get',
		params:data
	})
}

// export function jssdkConfig(params) {
// 	return request({
// 	  url: api.wechatJssdkConfig,
// 	  method: 'get',
// 	  params,
// 	  hideloading: true
// 	})
//   }
export function getrelated(data) {
	return request({
		url: `/api/live/v1/live/related`,
		method: 'post',
		data
	})
}
// 下定金提交
export function goodmakeorder(data) {
	return request({
		url: '/api/live/v1/makeorder',
		method: "POST",
		data,
	})
}
// 我的订单列表
export function myorders(data) {
	return request({
		url: '/api/live/v1/live/myorders',
		method: 'POST',
		data
	})
}

  
  